import React from 'react';
import './Header.styl';

export class Header extends React.Component {
  static propTypes = {
    title: React.PropTypes.string.isRequired,
    children: React.PropTypes.object,
    type: React.PropTypes.string,
  };

  render() {
    const {type, title, children} = this.props;

    return (
      <header className={`header__header ${type} ${this.props.className}`}>
        <div className="header__title">{title}</div>
        <div className="header__childen">{children}</div>
      </header>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/reactModules/shared/library/Header/Header.js